import './Contacts.css';
import { InstaSVG, FbSVG, TikTokSVG } from '../../assets/icons/icons';
import { Link } from 'react-router-dom';

function Contacts() {
    return(
        <div className="contacts-page">
            {/* Hero Section */}
            <div className="contacts-hero">
                <div className="contacts-hero-content">
                    <h1>Get In Touch</h1>
                    <p>Ready to transform your business? Let's discuss how we can help you achieve your goals.</p>
                </div>
            </div>

            {/* Contact Information Section */}
            <div className="contacts-info-section">
                <div className="contacts-container">
                    <div className="contacts-info-grid">
                        <div className="contacts-info-card">
                            <div className="contacts-info-icon">📧</div>
                            <h3>Email Us</h3>
                            <p>Scpogroupinc@gmail.com</p>
                        </div>
                        <div className="contacts-info-card">
                            <div className="contacts-info-icon">📞</div>
                            <h3>Call Us</h3>
                            <p>313 777-0707</p>
                        </div>
                        <div className="contacts-info-card">
                            <div className="contacts-info-icon">📍</div>
                            <h3>Visit Us</h3>
                            <p>320 West Maple Str, Glendale, CA 91204</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Map Section */}
            <div className="contacts-map-section">
                <div className="contacts-container">
                    <h2>Find Us</h2>
                    <div className="contacts-map-wrapper">
                        <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3302.350633094443!2d-118.25899419999999!3d34.137370499999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c0fb6693f91b%3A0xb2ce31498dc51088!2s320%20W%20Maple%20St%2C%20Glendale%2C%20CA%2091204%2C%20USA!5e0!3m2!1sen!2sam!4v1761588882011!5m2!1sen!2sam" 
                            width="100%"
                            height="450"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="SCPO Group Location">
                        </iframe>
                    </div>
                </div>
            </div>

            {/* Social Media Section */}
            <div className="contacts-social-section">
                <div className="contacts-container">
                    <div className="contacts-social-content">
                        <div className="contacts-social-text">
                            <h2>Follow Us</h2>
                            <p>Stay connected with SCPO Group and get the latest updates on our services, insights, and success stories.</p>
                        </div>
                        <div className="contacts-social-icons">
                            <a
                                href="https://www.facebook.com/profile.php?id=61582904572166&mibextid=wwXIfr&mibextid=wwXIfr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contacts-social-link">
                                <FbSVG />
                                <span>Facebook</span>
                            </a>
                            <a
                                href="https://www.instagram.com/scpo_group?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contacts-social-link">
                                <InstaSVG />
                                <span>Instagram</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contacts